import React, { memo, useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';

// eslint-disable-next-line react/display-name
const SvgIconPdf = memo(({ disabled = false, onClick, style, ...props }) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            width={50}
            height={50}
            viewBox='0  0 50 50'
            fill={disabled ? '' : '#CC0000'}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(
                ref,
                disabled,
                onClick,
                disabled ? '' : '#CC0000'
            )}
            {...props}
        >
            <g>
                <path
                    d='M33.3,30.2c0.8,0,1-0.2,1-1c0-3.4,0-6.8,0-10.2c0-0.7-0.2-0.9-0.9-0.9c-0.1,0-0.3,0-0.4,0c-7.8,0-15.6,0-23.4,0
                    c-0.4,0-0.8,0.1-1,0.5v11.2c0.2,0.4,0.6,0.5,1.1,0.5c4.7,0,9.4,0,14.1,0C27,30.2,30.1,30.2,33.3,30.2z M25.9,20.9h4.2V22h-2.7v1.5
                    h2.3v1.2h-2.3v2.5h-1.5V20.9z M19.3,23.2c-0.1,1-1,1.8-2,1.8c-0.4,0-0.9,0-1.4,0v2.2h-1.5v-6.3c1.1,0,2.2-0.1,3.2,0
                    C18.8,21.1,19.4,22.1,19.3,23.2z M20.1,27.2v-6.4c0.9,0,1.8,0,2.7,0C24,20.9,25,22,25,23.3c0,0.7,0,1.4-0.1,2.1
                    c-0.2,1.1-1.2,1.8-2.3,1.8C21.8,27.2,20.9,27.2,20.1,27.2z'
                />
                <path
                    d='M40.9,8.1c-1.3-1.3-2.6-2.6-3.9-3.9c-0.9-0.9-1.9-1.8-2.8-2.7H11.6C11.2,1.7,11,2.1,11,2.5c0,3.2,0,6.4,0,9.6
                    c0,1.2,0,2.4,0,3.6c0,0.5,0.1,0.6,0.6,0.6c0.3,0,0.6,0,0.9,0c0.2,0,0.3-0.2,0.4-0.4c0.1-0.1,0-0.4,0-0.5c0-3.8,0-7.6,0-11.5
                    c0-0.2,0-0.4,0-0.6h19.6v0.5c0,1.7,0,3.4,0,5.1c0,0.8,0.2,1,1,1c1.7,0,3.4,0,5.1,0c0.6,0,0.6,0,0.6,0.6c0,2,0,4,0,6c0,8,0,16,0,24
                    c0,0.6,0,0.7-0.7,0.7c-1.6,0-3.2,0-4.7,0c-1.5,0-1.1-0.2-2,1c-0.2,0.2-0.4,0.5-0.6,0.8c0.3,0,0.4,0,0.6,0c2.7,0,5.5,0,8.2,0
                    c0.8,0,1-0.2,1-1c0-11,0-22.1,0-33.1C41.3,8.7,41.2,8.4,40.9,8.1z'
                />
                <path
                    d='M33,38.8c-0.1-0.1-0.3-0.2-0.5-0.2c-0.7,0-1.4,0-2.1,0c-0.7,0-0.7-0.1-0.7-0.7c0-1.6,0-3.2,0-4.7c0-1-0.3-1.2-1.2-1.2
                    c-0.8,0-1.5,0-2.3,0v0c-0.9,0-1.7,0-2.6,0c-0.5,0-0.8,0.3-0.9,0.7c0,0.2,0,0.4,0,0.6c0,1.6,0,3.1,0,4.7c0,0.6,0,0.6-0.7,0.6
                    c-0.7,0-1.4,0-2.1,0c-0.2,0-0.5,0.1-0.5,0.2c-0.1,0.1,0.1,0.4,0.2,0.6c2,2.7,4.1,5.5,6.1,8.2c0.3,0.5,0.7,0.5,1.1,0
                    c0.3-0.3,0.5-0.7,0.8-1.1c1.8-2.4,3.5-4.8,5.3-7.2C33,39.2,33.1,38.9,33,38.8z'
                />
                <path
                    d='M19,41.3c-1.8,0-3.6,0-5.5,0c-0.5,0-0.6-0.1-0.6-0.6c0-2.6,0-5.2,0-7.7c0-1.3,0.1-1.2-1.3-1.2c-0.6,0-0.7,0.1-0.7,0.7
                    c0,3.2,0,6.5,0,9.7c0,0.8,0.2,1.1,1.1,1c2,0,4.1,0,6.1,0c0.9,0,1.7,0,2.7,0c-0.4-0.6-0.7-1-1-1.4C19.7,41.4,19.4,41.3,19,41.3z'
                />
                <path d='M21.6,22.1v4c0.2,0,0.5,0,0.7,0c0.6,0,1.1-0.2,1.2-0.9c0.1-0.8,0.1-1.5,0-2.3C23.3,22.1,22.7,21.9,21.6,22.1z' />
                <path
                    d='M17.1,22.1c-0.4,0-0.8,0-1.2,0v1.8c0.3,0,0.5,0,0.7,0c0.1,0,0.2,0,0.4,0c0.4-0.1,0.7-0.4,0.8-0.8
                    C17.8,22.5,17.5,22.1,17.1,22.1z'
                />
            </g>
        </svg>
    );
});

export default SvgIconPdf;
